import { axiosClient } from '../../clients/axios-client'
import type { ImatchResponseDto } from './dtos/imatch'
import { ImatchResponseDtoSchema } from './dtos/imatch'

export type SectionType = 'heading' | 'text' | 'table'

export interface WorkingDocumentSection {
  id: string
  type: SectionType
  title: string
  level?: number
  content: string
  children: WorkingDocumentSection[]
}

export interface CurrentDocument {
  sections: WorkingDocumentSection[]
}

interface PostImatchParams {
  currentDocument?: CurrentDocument
  mouseSelection?: string
  editorContent?: string
}

// iMatch can take longer on large documents/context, so avoid premature client-side aborts.
export const IMATCH_TIMEOUT = 5 * 60 * 1000

export async function postImatch({
  currentDocument,
  mouseSelection,
  editorContent,
}: PostImatchParams) {
  const match = []

  if (mouseSelection !== undefined) {
    match.push({ type: 'mouse_selection', content: mouseSelection })
  }

  if (editorContent !== undefined) {
    match.push({ type: 'editor_content', content: editorContent })
  }

  const payload = {
    ...(currentDocument !== undefined && { current_document: currentDocument }),
    match,
  }

  try {
    const { data } = await axiosClient.post<ImatchResponseDto>('/imatch', payload, {
      timeout: IMATCH_TIMEOUT,
    })
    const parsed = ImatchResponseDtoSchema.parse(data)
    return {
      matches: parsed.matches.map((file) => ({
        ...file,
        sections: file.sections.map((section) => ({
          ...section,
          type: section.type === 'section' ? ('heading' as const) : section.type,
        })),
      })),
    }
  } catch (error) {
    console.error('Error calling imatch', error)
    throw error
  }
}
